import 'regenerator-runtime/runtime';
import {
  call, put, fork, takeEvery,
} from 'redux-saga/effects';
import * as constants from 'constants/redux/cottage';
import * as actions from 'actions/cottage';
import * as cottagesActions from 'actions/cottages';
import * as userActions from 'actions';
import { parseError } from 'logic/helpers';
import api from 'api';
import { prepareUpdateCottageData } from 'logic/cottage';

function* fetchCottageRequest(req) {
  try {
    const { cottageId } = req.payload;
    const data = yield call(api.fetchCottage.bind(null, cottageId));
    yield put(actions.fetchCottageSuccess({ data }));
  } catch (e) {
    if (e.status === 401) {
      yield [
        put(actions.fetchCottageFailure({ error: {} })),
      ];
    } else {
      yield put(actions.fetchCottageFailure(parseError(e)));
    }
  }
}

function* createCottageRequest(req) {
  try {
    const { values } = req.payload;

    const body = prepareUpdateCottageData(values, 'base');
    const data = yield call(api.postCottage.bind(null, body));

    yield put(actions.updateCottageSuccess({ dialog: 'base', data }));
  } catch (e) {
    yield put(actions.updateCottageFailure({
      dialog: 'base',
      ...parseError(e),
    }));
  }
}

function* updateCottageRequest(req) {
  try {
    const {
      cottageId,
      dialog,
      values,
      updateCottages,
    } = req.payload;

    const body = prepareUpdateCottageData(values, dialog);
    const data = yield call(api.updateCottage.bind(null, cottageId, body));
    yield put(actions.updateCottageSuccess({ dialog, data }));

    if (updateCottages) {
      yield put(cottagesActions.updateCottagesData({ data }));
    }
  } catch (e) {
    const { dialog } = req.payload;
    yield put(actions.updateCottageFailure({
      dialog,
      ...parseError(e),
    }));
  }
}

function* removeCottageRequest(req) {
  try {
    const { cottageId } = req.payload;
    yield call(api.removeCottage.bind(null, cottageId));
    yield put(actions.removeCottageSuccess());
    yield put(cottagesActions.fetchCottagesRequest());
  } catch (e) {
    yield put(actions.removeCottageFailure(parseError(e)));
  }
}

function* lastMinuteDealsRequest(req) {
  try {
    const { cottageId } = req.payload;
    const data = yield call(api.fetchLastMinuteDeals.bind(null, cottageId));
    yield put(actions.lastMinuteDealsSuccess({ data }));
  } catch (e) {
    if (e.status === 401) {
      yield [
        put(actions.lastMinuteDealsFailure({ error: {} })),
      ];
    } else {
      yield put(actions.lastMinuteDealsFailure(parseError(e)));
    }
  }
}

function* lastMinuteDealsDelete(req) {
  try {
    const { cottageId, lastMinuteId } = req.payload;
    const data = yield call(api.deleteLastMinuteDeals.bind(null, cottageId, lastMinuteId));
    yield put(actions.lastMinuteDealsSuccess({ data }));
    yield put(actions.lastMinuteDealsDeleteSuccess());
  } catch (e) {
    if (e.status === 401) {
      yield [
        put(actions.lastMinuteDealsFailure({ error: {} })),
      ];
    } else {
      yield put(actions.lastMinuteDealsFailure(parseError(e)));
    }
  }
}

function* lastMinuteDealsCreate(req) {
  try {
    const { cottageId, values } = req.payload;
    const data = yield call(api.postLastMinuteDeals.bind(null, cottageId, values));
    yield put(actions.lastMinuteDealsSuccess({ data: [data] }));
    yield put(actions.lastMinuteDealsCreateSuccess());
  } catch (e) {
    if (e.status === 401) {
      yield [
        put(actions.lastMinuteDealsFailure({ error: {} })),
      ];
    } else {
      yield put(actions.lastMinuteDealsFailure(parseError(e)));
    }
  }
}

function* cottageVerification(req) {
  try {
    const { cottageId, dialog } = req.payload;
    const data = yield call(api.verifyCottage.bind(null, cottageId));
    yield put(actions.updateCottageSuccess({ dialog, data }));
  } catch (e) {
    const { dialog } = req.payload;
    yield put(actions.updateCottageFailure({
      dialog,
      ...parseError(e),
    }));
    yield put(userActions.fetchUserSelfRequest());
  }
}

export default [
  fork(takeEvery, constants.FETCH_COTTAGE_REQUEST, fetchCottageRequest),
  fork(takeEvery, constants.REMOVE_COTTAGE_REQUEST, removeCottageRequest),
  fork(takeEvery, constants.UPDATE_COTTAGE_REQUEST, updateCottageRequest),
  fork(takeEvery, constants.CREATE_COTTAGE_REQUEST, createCottageRequest),

  fork(takeEvery, constants.LAST_MINUTE_DEALS_REQUEST, lastMinuteDealsRequest),
  fork(takeEvery, constants.LAST_MINUTE_DEALS_DELETE, lastMinuteDealsDelete),
  fork(takeEvery, constants.LAST_MINUTE_DEALS_CREATE, lastMinuteDealsCreate),

  fork(takeEvery, constants.COTTAGE_VERIFICATION_REQUEST, cottageVerification),
];
